<template>
    <div class="newsPage-cate-content scroll-container">
        <div class="newsPage-cate" v-bind:class="{active: activeIndex === 1}" @click="changeTab(1)">
            <span>大事记</span>
        </div>
        <div class="line"></div>
        <div class="newsPage-cate" v-bind:class="{active: activeIndex === 2}" @click="changeTab(2)">
            <span>重要公告</span>
            <div class="newsPage-count" v-if="newsCount>0">{{newsCount}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NewsNav',
        props: {
            activeIndex: {
                type: Number,
                default: 0
            },
            newsCount: {
                type: Number,
                default: 0
            }
        },
        watch: {
            'activeIndex' (newVal) {
                console.log(newVal)
            }
        },
        methods: {
            changeTab (type) {
                if (this.activeIndex === type) return false
                this.$emit('on-change', type)
                this.$router.push(`/Rccl.CustomPage/RcclNews?newsType=${type}`)
            }
        }
    }
</script>

<style lang="less" scoped>
    /**** nav ****/
    .newsPage-cate-content {
        height: 42px;
        text-align: center;
        font-size: 14px;
        background-color: white;
        border-bottom: 1px solid #ddd;
        .newsPage-cate {
            display: inline-block;
            vertical-align: middle;
            width: 48%;
            margin-top: 5px;
            position: relative;
            &>span{
                font-weight:bold;
            }
            &.active{
                span {
                    color: #061556;
                    border-bottom: 2px solid #f9b811;
                    padding-bottom: 6px;
                }
            }
        }
        .line {
            display: inline-block;
            vertical-align: middle;
            width: 1px;
            background-color: #ddd;
            margin-top: 6px;
            height: 30px;
        }
        .newsPage-count {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: red;
            line-height: 16px;
            border-radius: 9px;
            color: white;
            top: -4px;
            right: 42px;
            font-size: 12px;
        }
    }
</style>
